import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { Observable } from 'rxjs/Observable';
import { tap, catchError } from 'rxjs/operators';
import { DataSummary } from '../models/reports/dataSummary';
import { ClientBalanceReport } from '../models/reports/client.balance.report';
import { ClientBalanceReportFilter } from '../models/reports/client.balance.report.filter';
import { DailyCollectible } from '../models/reports/daily.collectible';

@Injectable()
export class ReportService {
	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getSummary(): Observable<DataSummary> {
		return this._http.get<DataSummary>(`${this.origin}/api/reports`)
			.pipe(
				tap(x => this.log(`getSummary`)),
				catchError(this._logService.handleError<DataSummary>('getSummary'))
			);
	}

	getDailyTripCountSummary(): Observable<DataSummary> {
		return this._http.get<DataSummary>(`${this.origin}/api/reports/daily-trip-counts`)
			.pipe(
				tap(x => this.log(`getDailyTripCountSummary`)),
				catchError(this._logService.handleError<DataSummary>('getDailyTripCountSummary'))
			);
	}

	getBalance(filter: ClientBalanceReportFilter): Observable<ClientBalanceReport[]> {
		var queryString = this._common.objectToQueryParam(filter);
		return this._http.get<ClientBalanceReport[]>(`${this.origin}/api/reports/balance${queryString}`)
			.pipe(
				tap(x => this.log(`getBalance`)),
				catchError(this._logService.handleError<ClientBalanceReport[]>('getBalance'))
			);
	}

	getExportBalanceUrl(filter: ClientBalanceReportFilter) {
		var queryString = this._common.objectToQueryParam(filter);
		return this._http.get(`${this.origin}/api/reports/balance/export${queryString}`, {responseType: 'arraybuffer'});
    }
    
    getDailyCollectible(date: string): Observable<DailyCollectible> {
		return this._http.get<DailyCollectible>(`${this.origin}/api/reports/dailycollectibles?date=${date}`)
			.pipe(
				tap(x => this.log('getDailyCollectible')),
				catchError(this._logService.handleError<DailyCollectible>('getDailyCollectible'))
			);
	}

	private log(message: string) {
		this._messagesService.add('ReportService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/report.service.ts